import { DeliveryCompaniesRepository } from '../repositories/delivery-companies.repository'

import {
    DeliveryCompanyPayload,
    GetBillingDeliveryCompaniesParams,
    GetBillingDeliveryCompaniesResponse,
    GetDeliveryCompaniesParams,
    GetDeliveryCompaniesResponse,
    GetDeliveryCompanyResponse,
} from '@/core/types/delivery-companies.types'

const deliveryCompaniesRepository = new DeliveryCompaniesRepository()

export class DeliveryCompaniesService {
    async getCompanies(params: GetDeliveryCompaniesParams): Promise<GetDeliveryCompaniesResponse> {
        const response = await deliveryCompaniesRepository.getCompanies(params)
        return response.data
    }

    async getCompany(company_id: number): Promise<GetDeliveryCompanyResponse> {
        const response = await deliveryCompaniesRepository.getCompany(company_id)
        return response.data
    }

    async createCompany(payload: FormData): Promise<void> {
        const response = await deliveryCompaniesRepository.createCompany(payload)
        return response.data
    }

    async updateCompany(company_id: number, payload: DeliveryCompanyPayload): Promise<void> {
        const response = await deliveryCompaniesRepository.updateCompany(company_id, payload)
        return response.data
    }

    async deleteCompany(company_id: number): Promise<void> {
        const response = await deliveryCompaniesRepository.deleteCompany(company_id)
        return response.data
    }

    async getBillingCompanies(
        params: GetBillingDeliveryCompaniesParams
    ): Promise<GetBillingDeliveryCompaniesResponse> {
        const response = await deliveryCompaniesRepository.getBillingCompanies(params)
        return response.data
    }
}
